import type { ActivityDraft, ActivityPatch } from "@/data/repos/partnerActivitiesRepo";
import type { ActivityFormData } from "@/features/activities/form-schema";
import { rowsToDefinitions } from "@/features/custom-fields/form-schema";

function partnerAuthoredFields(
  data: ActivityFormData,
): Omit<ActivityDraft, "reservationUrl"> {
  return {
    name: data.activity_name,
    subcategoryId: data.activity_subcategory_id,
    bookingMode: data.booking_mode,
    priceOriginal: data.price_original,
    imageUrl: data.image_url,
    description: data.description?.trim() ? data.description.trim() : null,
    customFields: data.custom_fields.length ? rowsToDefinitions(data.custom_fields) : null,
    defaultPriceDiscounted: data.default_price_discounted ?? null,
    defaultCapacity: data.default_capacity ?? null,
    saleLeadTimeHours: data.sale_lead_time_hours ?? null,
    saleEndOffsetMinutes: data.sale_end_offset_minutes ?? null,
    saleEndAnchor: data.sale_end_anchor ?? null,
    defaultDurationMinutes: data.default_duration_minutes ?? null,
    requiresConfirmation: data.requires_confirmation,
  };
}

export function toActivityCreateInput(data: ActivityFormData): ActivityDraft {
  return { ...partnerAuthoredFields(data), reservationUrl: null };
}

/** Without a `reservationUrl` key the update leaves the stored booking link alone —
 *  partners no longer author it, and the stored links feed the paid-reservation
 *  migration, so an edit must neither null nor rewrite them. */
export function toActivityUpdateInput(data: ActivityFormData): ActivityPatch {
  return partnerAuthoredFields(data);
}
